<template>
    <div>
        <SingleReportHeader :dataFrom="table.params" @search="searchData" :toPdf="eleToPdf" :excelShow="false"></SingleReportHeader>
        <div ref="tableRef">
            <div v-for="(item, index) in table.data" style="margin-bottom: 10px">
                <div class="table-title">{{ item.name }}</div>
                <Table border :columns="item.columns" :data="item.data" :row-class-name="rowClassName"></Table>
            </div>
        </div>
    </div>
</template>

<script>
import SingleReportHeader from './components/single_report_header.vue'
import { TransTopReq } from '@/api/admin/risk'
import moment from 'moment'

//子商户
报表数据
export default {
    name: 'HandicapChannelData',
    components: { SingleReportHeader },
    data() {
        return {
            table: {
                params: {
                    platid: 0,
                    app_id: 0,
                    dataTime: this.getCurrentZeroDay()
                },
                data: []
            }
        }
    },
    methods: {
        //查询数据
        async searchData() {
            let platname = this.plat_list.find((el) => el.id == this.table.params.platid).name
            let appname = this.app_list.find((el) => el.appid == this.table.params.app_id).appName
            let params = this.getTransTopParams('GetPlatformGeneralSumData', {
                platid: this.table.params.platid,
                platname,
                appname,
                app_id: this.table.params.app_id,
                stime: this.getSecond(this.table.params.dataTime),
                etime: this.getSecond(this.table.params.dataTime, false),
                general: -1,
                pack_no: -1,
                page: 1,
                sort: 0,
                limt: 10000
            })
            let params1 = this.copyData(params)
            params1.param._param.stime = params1.param._param.stime - 24 * 60 * 60
            params1.param._param.etime = params1.param._param.etime - 24 * 60 * 60
            this.table.data = []
            await this.httpData(params)
            this.httpData(params1)
        },
        async httpData(params) {
            let res = await TransTopReq(params)
            let columns = [{ key: 'key', title: '商户信息', align: 'center', width: 90 }]
            let columnsData = [
                { key: '转入金额', field: 'pay_sum' },
                { key: '转入人数', field: 'pay_user_num', className: 'r-218238243' },
                { key: '转出金额', field: 'put_sum' },
                { key: '营收金额', field: 'loss_point', className: 'r-218238243' },
                { key: '转入投注人数', field: 'pay_bet_user_num', className: 'r-243165173' },
                { key: '投注金额', field: 'bet_sum' },
                { key: '游戏盈亏', field: 'loss_sum' },
                { key: '税收金额', field: 'percent_sum' },
                { key: '盈亏税收比', field: 'percent_loss_rate' },
                { key: '盈亏投注比', field: 'loss_bet_rate', className: 'r-218238243' },
                { key: '赠送金额', field: 'give_sum' },
                { key: '新增用户数', field: 'new_user_num' },
                { key: '新增绑定用户数', field: 'new_bind_num', className: 'r-218238243' },
                { key: '活跃用户数', field: 'active_num' },
                { key: '新增用户转入人数', field: 'new_user_pay_num' },
                { key: '新增付费率', field: 'new_pay_rate', className: 'r-218238243' },
                { key: '新增转入金额', field: 'new_pay_sum', className: 'r-218238243' },
                { key: '昨日新增转入次日复充率', field: 'one_pay_rate', className: 'r-218238243' },
                { key: '首充人数', field: 'first_pay_num', className: 'r-218238243' },
                { key: '首充金额', field: 'first_total_pay_sum' },
                { key: '首充新增比', field: 'new_pay_first_pay' },
                { key: '佣金', field: 'send_percent_sum', className: 'r-218238243' },
                { key: '佣金发放人数', field: 'send_percent_num' }
            ]
            let data = (res._param.data || []).filter((el) => {
                let result = false
                for (let key in el) {
                    if (key != 'general_id' && key != 'general_name') {
                        result = !!el[key]
                    }
                    if (result) break
                }
                return result
            })
            data.forEach((item) => {
                let columnsItem = {
                    key: `${item.general_id}`,
                    title: item.general_id > -1 ? `${item.general_name} (${item.general_id})` : '合计',
                    align: 'center',
                    minWidth: 120,
                    render: (h, params) => {
                        let field = params.row.field
                        let key = params.row.key
                        let value = params.row[params.column.key]
                        if (field.includes('_rate') || key.includes('比')) {
                            return h('span', (value * 100 || 0).toFixed(2) + '%')
                        } else if (field.includes('_sum') || field.includes('_point')) {
                            return h('span', this.getCustomFixed(value / 10000))
                        } else {
                            return h('span', this.getCustomFixed(value))
                        }
                    }
                }
                columns.push(columnsItem)
                columnsData.forEach((el) => {
                    el[`${item.general_id}`] = item[el.field]
                })
            })
            if (columns.length > 1) {
                this.table.data.push({
                    name: `${params.appname} 各子商户
数据统计表(${moment(params.param._param.stime * 1000).format('YYYY-MM-DD')})`,
                    columns,
                    data: columnsData
                })
            }
        },
        rowClassName(row, index) {
            return row.className || ''
        },
        //透传接口请求参数 请求方法 请求参数
        getTransTopParams(func, param) {
            return {
                mod: 'root',
                platid: this.table.params.platid,
                app_id: this.table.params.app_id,
                platname: param.platname,
                appname: param.appname,
                param: {
                    _mod: 'manager',
                    _func: func,
                    _param: { ...param }
                }
            }
        }
    }
}
</script>

<style scoped lang="less">
.table-title {
    text-align: center;
    background-color: #eee;
    height: 50px;
    line-height: 50px;
    font-size: 16px;
    font-weight: bold;
    border-right: 1px solid rgb(145, 145, 145) !important;
    border-top: 1px solid rgb(145, 145, 145) !important;
    border-left: 1px solid rgb(145, 145, 145) !important;
}
/deep/ .ivu-table .r-243165173 td:not(:first-of-type) {
    background-color: RGB(243, 165, 173);
}
/deep/ .ivu-table .r-218238243 td:not(:first-of-type) {
    background-color: RGB(218, 238, 243);
}
/deep/ .ivu-table-border th {
    border-right: 1px solid rgb(145, 145, 145) !important;
}
/deep/ .ivu-table-border td {
    border-right: 1px solid rgb(145, 145, 145) !important;
}
/deep/ .ivu-table th {
    border-bottom: 1px solid rgb(145, 145, 145) !important;
}
/deep/ .ivu-table td {
    border-bottom: 1px solid rgb(145, 145, 145) !important;
}
/deep/ .ivu-table-wrapper-with-border {
    border: 1px solid rgb(145, 145, 145) !important;
}
// rgb(91,155,213)
</style>
